import OkTableConfigType from '@/@bya3/components/tables/ok-table/OkTableConfigType'
import { API_URL } from '@/constants/config'

const ReportsTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/admin/instagram/replies`,
  rowsPath: 'replies',
  rowClickable: true,
  attachPageId: false,
  columns: [
    {
      label: 'reply.template_name',
      field: 'name',
    },
    {
      label: 'reply.author',
      field: 'account_name',
    },
    {
      label: 'reply.author',
      field: 'user',
    },
    {
      label: 'reply.post',
      field: 'post',
    },
    {
      label: 'reply.message_type',
      field: 'type',
    },
    {
      label: 'reply.replies_count',
      field: 'replies_count',
    },
    {
      label: 'reply.status',
      field: 'status',
    },
    {
      label: 'reply.last_reply',
      field: 'last_reply',
    },
    {
      label: 'fields.created-at',
      field: 'created_at',
    },
    {
      label: 'forms.actions',
      field: 'actions',
    },
  ],
  paginationOptions: {
    enabled: true,
  },
  sortOptions: {
    enabled: false,
  },
  actions: [
  ],
  filters: [
  ],
}

export default ReportsTableConfig
